import { IIconProps }             from "modules/types";
import { ReactComponent as icon } from "./Star.svg";
import React                      from "react";

export const IconStar = (props: IIconProps) =>
	React.createElement(icon, props);